import Styles from './BrandVisualStyleMedia.module.scss'
import { ImageThumbnail } from 'components/ImagePickerModal/ImageThumbnail/ImageThumbnail'
import { Trash2 } from 'blaze-ui/icons'
import { useQueryClient } from 'react-query'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { BrandKitShow } from 'types'
import { Data as BrandKitData } from 'hooks/queries/brandKits/useBrandKit'
import { IMediaFile } from 'components/Design/UploadsTab/Types'

export const MediaFilesGrid = ({
  mediaFiles,
  showAllMediaFiles,
  onDelete,
  brandKitId,
  onShowAllMediaFiles,
}: {
  mediaFiles: IMediaFile[]
  showAllMediaFiles: boolean
  onShowAllMediaFiles: (showAll: boolean) => void
  onDelete: (id: number) => void
  brandKitId: number
}) => {
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceId()

  return (
    <div className={Styles.mediaGrid}>
      {mediaFiles.slice(0, showAllMediaFiles ? mediaFiles.length : 9).map((mediaFile) => (
        <div className={Styles.mediaItem} key={mediaFile.id}>
          <ImageThumbnail
            image={{ ...mediaFile, url: mediaFile.thumbnail_url || mediaFile.source_url }}
            duration={mediaFile.duration}
          />
          <IconButton
            icon={Trash2}
            className={Styles.deleteButton}
            size="xs"
            variant="secondary"
            rounded
            onPress={() => {
              if (mediaFile.asset_id) {
                const queryKey = ['workspaces', workspaceId, 'brandKits', 'detail', brandKitId] as const

                queryClient.getQueriesData<BrandKitData>(queryKey)?.forEach(([queryKey, data]) => {
                  if (data) {
                    queryClient.setQueryData<{ brand_kit: BrandKitShow }>(queryKey, {
                      brand_kit: {
                        ...data.brand_kit,
                        media_files: data.brand_kit.media_files.filter((m) => m.id !== mediaFile.id),
                      },
                    })
                  }
                })
                onDelete(mediaFile.asset_id)
              }
            }}
          />
        </div>
      ))}
      {!showAllMediaFiles && mediaFiles.length > 9 && (
        <button className={Styles.seeAllButton} onClick={() => onShowAllMediaFiles(true)}>
          <div className={Styles.seeAllBadge}>+{mediaFiles.length - 9}</div>
          <div className={Styles.seeAllText}>See All</div>
        </button>
      )}
    </div>
  )
}
